import { Typography } from "antd"
import React, { type ReactNode } from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

interface WorkspaceCardValueProps {
  value?: ReactNode
  placeholder?: string
  children?: ReactNode
}

const isAbsent = (value: ReactNode) =>
  value == null ||
  value === false ||
  (typeof value === "string" && !value.trim()) ||
  (Array.isArray(value) && !value.length)

/** An unset optional value is muted, never an error reading. */
function WorkspaceCardValue({
  value,
  placeholder,
  children
}: WorkspaceCardValueProps) {
  const { t } = useTranslation()

  if (isAbsent(value))
    return (
      <Text type={"secondary"} data-testid={"workspace-card-empty"}>
        {placeholder ?? t("leadWorkspace.card.empty")}
      </Text>
    )

  return <>{children ?? <Text>{value}</Text>}</>
}

export { WorkspaceCardValue }
